import { Box, Stack, Typography } from '@mui/material';
import { Slide } from 'react-awesome-reveal';
import sectionConstants from '../../constants/SectionConstants';
import '../styles/Section1.scss';

const Section1 = () => {
  return (
    <Box className='section1-image'>
      <Stack className='section1-heading' spacing={2}>
        <Typography className='section1-heading-data1'>
          <Slide>{sectionConstants.VehicleManagementandTrackingSystem}</Slide>
        </Typography>
        <Typography className='section1-heading-data2'>
          <Slide>{sectionConstants.EffortlessFleetControl}</Slide>
        </Typography>
      </Stack>
    </Box>
  );
};

export default Section1;
